<mat-icon
  [svgIcon]="name"
  [ngStyle]="{
    'width.px': size,
    'height.px': size,
    'font-size.px': size,
    'color': color
  }"
  class="app-icon"
></mat-icon>
